import { Node } from 'reactflow'
import { BaseNodeData } from '../../base/types'
import { NodeTypes } from '../../../../../../shared/models/rule-node'
import { EntityType } from '../../../../../../shared/models/entity-type.models'
import { Col, Form, Row } from 'react-bootstrap'
import Input from '../../../../../../components/form/Input'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { Select } from '../../../../../../components/page-components/selects-entities/generic-select/Select'
import { SelectableValue } from '../../../../../../components/page-components/selects-entities/generic-select/selectable-value'
import _ from 'lodash'
import React from 'react'
import { AssetProfileId } from '../../../../../../shared/models/id/asset-profile-id'
import GenericSelect from '../../../../../../components/page-components/selects-entities/GenericSelect'
import {
  useLazyGetAssetProfileQuery,
  useLazyGetAssetProfilesQuery,
} from '../../../../../../store/kopiliot-api/asset-profile'

export interface ActionEntityOperationFindOrCreateConfiguration {
  entityType: EntityType
  prefixNamePattern: string
  entityNamePattern: string
  nameKey: string
  idKey: string
  limit: number
  additionalSettings?: ActionCreateAssetSettings
}

interface ActionCreateAssetSettings {
  assetProfileID: AssetProfileId
}

interface Props {
  onSubmit: (
    data: Node<
      BaseNodeData<ActionEntityOperationFindOrCreateConfiguration>,
      NodeTypes.ACTION_ENTITY_OPERATION_FIND_OR_CREATE
    >
  ) => void
  defaultValues: Node<
    BaseNodeData<ActionEntityOperationFindOrCreateConfiguration>,
    NodeTypes.ACTION_ENTITY_OPERATION_FIND_OR_CREATE
  >
}

const ActionEntityOperationFindOrCreateForm = ({
  onSubmit,
  defaultValues,
}: Props) => {
  const form = useForm<
    Node<
      BaseNodeData<ActionEntityOperationFindOrCreateConfiguration>,
      NodeTypes.ACTION_ENTITY_OPERATION_FIND_OR_CREATE
    >
  >({
    defaultValues,
  })
  const fullWatch = form.watch()
  const options = [{ label: 'ASSET', value: EntityType.ASSET }]
  return (
    <FormProvider {...form}>
      <Form
        noValidate
        onSubmit={form.handleSubmit(onSubmit)}
        id={'form_rule_node'}
        className={'min-h-100'}
      >
        <Row className={''}>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={form.register('data.name', {
                required: 'Le nom est obligatoire',
              })}
              label={'Nom'}
              error={form.formState.errors?.data?.name}
            />
          </Form.Group>
          <Form.Group
            as={Col}
            lg={6}
            md={12}
            className={'d-flex align-items-center'}
          >
            <Form.Check
              className={'mt-auto'}
              type="switch"
              label="Debug Mode ?"
              {...form.register('data.isDebugMode')}
            />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} lg={3} md={12}>
            <Input
              type={'number'}
              register={form.register('data.configuration.limit', {
                required: 'La limite est obligatoire',
                valueAsNumber: true,
              })}
              label={'Limite'}
              error={form.formState.errors?.data?.configuration?.limit}
            />
          </Form.Group>
          <Form.Group as={Col} lg={3} md={12}>
            <Input
              register={form.register('data.configuration.idKey')}
              label={"Clé pour l'ID"}
              error={form.formState.errors?.data?.configuration?.idKey}
            />
          </Form.Group>
          <Form.Group as={Col} lg={3} md={12}>
            <Input
              register={form.register('data.configuration.nameKey')}
              label={'Clé pour le nom'}
              error={form.formState.errors?.data?.configuration?.nameKey}
            />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={form.register('data.configuration.prefixNamePattern')}
              label={"Prefix pour le nom de l'entité"}
              error={
                form.formState.errors?.data?.configuration?.prefixNamePattern
              }
            />
          </Form.Group>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={form.register('data.configuration.entityNamePattern')}
              label={"Pattern pour le nom de l'entité"}
              error={
                form.formState.errors?.data?.configuration?.entityNamePattern
              }
            />
          </Form.Group>
        </Row>
        <Row className={''}>
          <Form.Group as={Col} lg={6} md={12}>
            <Form.Label htmlFor={'data.configuration.entityType'}>
              Entity type
            </Form.Label>
            <Controller
              name={'data.configuration.entityType'}
              render={({ field: { onChange, value } }) => {
                return (
                  <Select
                    classNamePrefix={'react-select'}
                    options={options}
                    value={value}
                    onChange={(value: SelectableValue) => {
                      onChange(value?.value)
                    }}
                    {..._.omit(
                      form.register('data.configuration.entityType', {
                        shouldUnregister: true,
                      }),
                      ['onChange']
                    )}
                  />
                )
              }}
            />
          </Form.Group>
        </Row>
        <Row className={'pt-2'}>
          <h3>Settings</h3>
          <Form.Group as={Col} lg={6} md={12}>
            <Row className={'gx-3 gy-2 align-items-center'}>
              <Col md={6}>
                <GenericSelect
                  register={form.register(
                    'data.configuration.additionalSettings.assetProfileID',
                    {
                      required: 'The asset profile is required',
                    }
                  )}
                  /*isDisabled={isLoadingForm}
                  error={
                    errors.assetProfileID ? errors.assetProfileID.id : undefined
                  }*/
                  getQuery={useLazyGetAssetProfileQuery}
                  listQuery={useLazyGetAssetProfilesQuery}
                  label={'Asset profile'}
                  valueConstructor={(value) => new AssetProfileId(value)}
                />
              </Col>
            </Row>
          </Form.Group>
        </Row>
      </Form>
    </FormProvider>
  )
}

export default ActionEntityOperationFindOrCreateForm
